




































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { storeDokter } from "@/store/modules/dokter";
import { storePasien } from "@/store/modules/pasien";
import RujukanHivSvc from "@/services/RujukanHivService";
import { RujukanHivInterface } from "@/types/rujukan_hiv";

const INSTANSI_DEFAULT = "RSUD Panembahan Senopati Bantul";

@Component({
  inject: { isReadOnly: { default: () => () => false } }
})
export default class RujukanHivInputModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) editData!: RujukanHivInterface | null;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  saving = false;
  requiredRule = [(v: any) => !!v || "*Kolom ini harus diisi"];

  form = this.defaultForm();

  defaultForm() {
    return {
      instansi_pengirim: INSTANSI_DEFAULT,
      instansi_penerima: "",
      nama_pasien: "",
      no_reg_nasional: "",
      alamat_pasien: "",
      tgl_konfirmasi_hiv: "",
      tempat_konfirmasi_hiv: "",
      stadium_klinis_who: null as number | null,
      berat_badan: null as number | null,
      status_fungsional: null as string | null,
      status_tb: "",
      rejimen_arv: "",
      infeksi_oportunistik: "",
      profilaksis_io: "",
      dokter_pengirim_id: null as number | null,
      tgl_rujukan: localISODate(),
    };
  }

  get dialog() {
    return this.value;
  }

  set dialog(val: boolean) {
    this.$emit("input", val);
  }

  get listDokter() {
    return storeDokter.list;
  }

  get stateuser() {
    return userModule.user;
  }

  // Data otomatis dari master pasien — tampil saja, tidak ikut disimpan
  get autoNik() {
    return storePasien.identitasPasien?.nik || "-";
  }

  get autoTglLahirUmur() {
    const p = storePasien.identitasPasien;
    if (!p || !p.tgl_lahir) return "-";
    return p.usia ? `${p.tgl_lahir} (${p.usia})` : p.tgl_lahir;
  }

  get autoJenisKelamin() {
    return storePasien.identitasPasien?.jk || "-";
  }

  get autoTelp() {
    return storePasien.identitasPasien?.telp || "-";
  }

  @Watch("value")
  onDialogOpen(val: boolean) {
    if (!val) return;

    if (this.editData) {
      const e = this.editData;
      this.form = {
        instansi_pengirim: e.instansi_pengirim || INSTANSI_DEFAULT,
        instansi_penerima: e.instansi_penerima || "",
        nama_pasien: e.nama_pasien || "",
        no_reg_nasional: e.no_reg_nasional || "",
        alamat_pasien: e.alamat_pasien || "",
        tgl_konfirmasi_hiv: e.tgl_konfirmasi_hiv || "",
        tempat_konfirmasi_hiv: e.tempat_konfirmasi_hiv || "",
        stadium_klinis_who: e.stadium_klinis_who,
        berat_badan: e.berat_badan,
        status_fungsional: e.status_fungsional,
        status_tb: e.status_tb || "",
        rejimen_arv: e.rejimen_arv || "",
        infeksi_oportunistik: e.infeksi_oportunistik || "",
        profilaksis_io: e.profilaksis_io || "",
        dokter_pengirim_id: e.dokter_pengirim_id,
        tgl_rujukan: e.tgl_rujukan || localISODate(),
      };
    } else {
      this.form = this.defaultForm();
      const p = storePasien.identitasPasien;
      if (p) {
        this.form.nama_pasien = p.nama || "";
        this.form.alamat_pasien = p.alamat || "";
      }
      if ((this.stateuser.profesi || "").toLowerCase() === "dokter") {
        this.form.dokter_pengirim_id = this.stateuser.id;
      }
    }
  }

  get payload() {
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      ...this.form,
    };
  }

  async save() {
    if (this.readOnly) return;
    const form = this.$refs.form as any;
    if (!form.validate()) return;
    if (this.saving) return;

    this.saving = true;
    try {
      const resp = this.editData
        ? await RujukanHivSvc.update(this.editData.id, this.payload)
        : await RujukanHivSvc.create(this.payload);

      if (resp.data.status == "1") {
        this.$emit("saved");
        this.dialog = false;
      }
    } finally {
      this.saving = false;
    }
  }

  close() {
    this.dialog = false;
  }
}
